import { useSearch, Link } from '@tanstack/react-router'
import { CheckCircle } from 'lucide-react'
import { useTranslation } from '@/hooks/use-translation'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { Card } from '@/components/ui/card'
import AuthLayout from '../auth-layout'
import { UserAuthForm } from './components/user-auth-form'

export default function SignIn() {
  const { t } = useTranslation()
  const search = useSearch({ from: '/(auth)/sign-in' })

  return (
    <AuthLayout>
      <Card className='p-6'>
        {search.passwordReset === 'success' && (
          <Alert className='mb-4 border-green-200 bg-green-50 text-green-800'>
            <CheckCircle className='h-4 w-4' />
            <AlertDescription>
              {t(
                'Password reset successful! You can now sign in with your new password.'
              )}
            </AlertDescription>
          </Alert>
        )}
        <div className='flex flex-col space-y-2 text-left'>
          <h1 className='text-2xl font-semibold tracking-tight'>
            {t('Login')}
          </h1>
          <p className='text-sm text-muted-foreground'>
            {t('Enter your email and password below to log into your account')}
          </p>
        </div>
        <UserAuthForm />
        <p className='mt-4 text-center text-sm text-muted-foreground'>
          {t("Don't have an account?")}{' '}
          <Link
            to='/shop-sign-up'
            className='font-medium underline underline-offset-4 hover:text-primary'
          >
            {t('Sign up')}
          </Link>
        </p>
        <p className='mt-4 px-8 text-center text-sm text-muted-foreground'>
          {t('By clicking login, you agree to our')}{' '}
          <a
            href='/terms'
            className='underline underline-offset-4 hover:text-primary'
          >
            {t('Terms of Service')}
          </a>{' '}
          {t('and')}{' '}
          <a
            href='/privacy'
            className='underline underline-offset-4 hover:text-primary'
          >
            {t('Privacy Policy')}
          </a>
          .
        </p>
      </Card>
    </AuthLayout>
  )
}
